(ns hypnos.consumer.panels.consult.mouth-breathing-level
  "The consult mouth breathing level."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :mouth-breathing-level :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :mouth-breathing-level :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  []
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.mouth-breathing-level/statement)]]])

(defn mouth-breathing-level-field
  [state consult]
  [:div.field.has-check
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.mouth-breathing-level/question (:consult/service-type consult)))]]
   [:div.field-body
    [:div.field
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "mouth-breathing-level"
                      :checked   (= 0 (get-in @state [:consult :consult/mouth-breathing-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/mouth-breathing-level :value])
                                         new-value (when (-> e .-target .-checked) 0)
                                         changed?  (or (get-in @state [:consult :consult/mouth-breathing-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/mouth-breathing-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui/mouth-breathing-level-long 0)]]]
     [:br]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "mouth-breathing-level"
                      :checked   (= 1 (get-in @state [:consult :consult/mouth-breathing-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/mouth-breathing-level :value])
                                         new-value (when (-> e .-target .-checked) 1)
                                         changed?  (or (get-in @state [:consult :consult/mouth-breathing-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/mouth-breathing-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui/mouth-breathing-level-long 1)]]]
     [:br]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "mouth-breathing-level"
                      :checked   (= 2 (get-in @state [:consult :consult/mouth-breathing-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/mouth-breathing-level :value])
                                         new-value (when (-> e .-target .-checked) 2)
                                         changed?  (or (get-in @state [:consult :consult/mouth-breathing-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/mouth-breathing-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui/mouth-breathing-level-long 2)]]]
     [:br]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "mouth-breathing-level"
                      :checked   (= 3 (get-in @state [:consult :consult/mouth-breathing-level :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/mouth-breathing-level :value])
                                         new-value (when (-> e .-target .-checked) 3)
                                         changed?  (or (get-in @state [:consult :consult/mouth-breathing-level :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/mouth-breathing-level :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/mouth-breathing-level :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui/mouth-breathing-level-long 3)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The mouth-breathing level step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
     ;; statement
     [statement]
     ;; field
     [mouth-breathing-level-field state @consult]
     [:hr]
     ;; navigation
     [navigation state nav-fn]]))
